import { render, staticRenderFns } from "./LabeledText.vue?vue&type=template&id=19a7b124&scoped=true&"
import script from "./LabeledText.vue?vue&type=script&lang=ts&"
export * from "./LabeledText.vue?vue&type=script&lang=ts&"
import style0 from "./LabeledText.vue?vue&type=style&index=0&id=19a7b124&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7b124",
  null
  
)

export default component.exports